import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EventContent from './EventContent';
import moment from 'moment';
const DailyEventsModal = ({ open, onClose, date, events, onViewClick, onEventClick }) => {
    return (_jsx(Dialog, { open: open, onClose: onClose, maxWidth: "sm", fullWidth: true, PaperProps: {
            sx: {
                borderRadius: '16px',
                p: 0,
                overflow: 'hidden',
                maxHeight: '600px',
                boxShadow: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)'
            }
        }, children: _jsxs(Box, { sx: { p: 1, position: 'relative' }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', mb: 3, position: 'relative' }, children: [_jsx(Typography, { sx: { flex: 1, textAlign: 'center', fontSize: '24px', fontWeight: 600, color: '#101828' }, children: date ? moment(date).format('D ddd') : '' }), _jsx(IconButton, { onClick: onClose, sx: {
                                color: '#667085',
                                position: 'absolute',
                                right: -10,
                                top: -10
                            }, children: _jsx(CloseIcon, {}) })] }), _jsx(Box, { sx: {
                        maxHeight: '450px',
                        overflowY: 'auto',
                        pr: 1.5,
                        '&::-webkit-scrollbar': { width: '8px' },
                        '&::-webkit-scrollbar-thumb': { background: '#EAECF0', borderRadius: '8px' },
                        '&::-webkit-scrollbar-track': { background: 'transparent' }
                    }, children: _jsx(Box, { sx: { display: 'flex', flexDirection: 'column', }, children: events.map((event, index) => {
                            const props = event.extendedProps || {};
                            const type = props.type?.toLowerCase();
                            const isHoliday = props.isHoliday || type === 'holiday';
                            const isPerformance = type === 'performance';
                            const isDraftOrProposal = type === 'draft' || type === 'proposal';
                            // Exclude holidays and non-campaign events from modal popup
                            if (isHoliday || (!isPerformance && !isDraftOrProposal)) {
                                return null;
                            }
                            return (_jsx(Box, { onClick: () => onEventClick({ event }), sx: {
                                    cursor: 'pointer',
                                    padding: 1,
                                    '& .event-wrapper': {
                                        margin: 0,
                                        width: '100%',
                                        padding: '14px 16px',
                                        borderRadius: '8px',
                                        position: 'relative',
                                        border: '1px solid #EAECF0',
                                        boxShadow: 'none',
                                        bgcolor: '#fff'
                                    }
                                }, children: _jsx(EventContent, { eventInfo: { event }, onViewClick: onViewClick, showAll: true }) }, index));
                        }) }) })] }) }));
};
export default DailyEventsModal;
